import { useAppSelector } from 'hooks';
import { getCarrierSettings } from 'views/shared/MethodOfPayment/helpers';
import {
  AUTO_PAYMENT_OPTIONS,
  PROPERTY_PAYMENT_OPTIONS,
} from 'views/shared/MethodOfPayment/configs';

interface UseRequireBillingOptions {
  formStateKey: 'autoPersonalForm' | 'homePersonalForm' | 'commercialForm';
}

export const useRequireBilling = ({
  formStateKey,
}: UseRequireBillingOptions): boolean => {
  return useAppSelector((state) => {
    if (formStateKey === 'commercialForm') {
      return true;
    }

    const isLOA = state[formStateKey].data?.policy_information?.is_loa || false;

    if (!isLOA) {
      return true;
    }

    const insuranceCompany =
      formStateKey === 'autoPersonalForm'
        ? state.autoPersonalForm.data?.company_and_broker_information
            ?.insurance_company
        : state.homePersonalForm.data?.policy_information?.insurance_company;

    const paymentOptions =
      formStateKey === 'autoPersonalForm'
        ? AUTO_PAYMENT_OPTIONS
        : PROPERTY_PAYMENT_OPTIONS;

    const carrierSettings = getCarrierSettings(
      insuranceCompany || '',
      paymentOptions,
    );
    const isBillingRequired = carrierSettings?.loa_billing_required || false;

    return (
      isBillingRequired ||
      state[formStateKey].data?.method_of_payment?.require_billing ||
      false
    );
  });
};
